import { Lightning } from '@lightningjs/sdk';
import FlareShader from '../shaders/flare.shader';
import { WHITE } from '../utils/colors';

export default class SkeletonRectangle extends Lightning.Component {
  static _template() {
    return {
      rect: true,
      color: WHITE,
      shader: { type: FlareShader, radius: 0 },
    };
  }

  _attach() {
    const flareWidth = window.innerWidth * 1.4;

    this.animation({
      duration: 2,
      repeat: -1,
      stopMethod: 'immediate',
      actions: [{ p: 'shader.lineX', v: { 0: -flareWidth, 1: flareWidth } }],
    }).start();
  }

  set radius(value) {
    this.shader.radius = value;
  }
}
